import { TEXT_ALIGN_TYPES } from "@shared/constants/index";
import React from "react";
import { useSlate } from "slate-react";

import EditorButton from "./EditorButton";
import { BLOCK_TYPES, isBlockActive, toggleBlock } from "../utils";

import { BLOCK_BUTTON_FORMAT, BlockButtonFormatType } from "../constants";

type BlockButtonPropsType = {
  format: BlockButtonFormatType;
  icon: React.JSX.Element;
  readOnly: boolean;
};

const BlockButton = ({ format, icon, readOnly }: BlockButtonPropsType) => {
  const editor = useSlate();

  return (
    <EditorButton
      active={isBlockActive(
        editor,
        format,
        TEXT_ALIGN_TYPES.includes(format)
          ? BLOCK_TYPES.ALIGN
          : BLOCK_TYPES.TYPE,
      )}
      onMouseDown={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (readOnly) return;
        event.preventDefault();
        toggleBlock(editor, format);
      }}
    >
      {icon}
    </EditorButton>
  );
};

export default BlockButton;
